const BASE_URL = process.env.REACT_APP_API_URL + '/api';

async function request(path, options = {}) {
  const token = localStorage.getItem('token');
  const response = await fetch(`${BASE_URL}${path}`, {
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    ...options,
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.error || 'Помилка запиту');
  return data;
}

export const productsApi = {
  getAll: (category) => request(`/products${category ? `?cat=${category}` : ''}`),
  getOne: (id) => request(`/products/${id}`),
  create: (data) => request('/products', { method: 'POST', body: JSON.stringify(data) }),
  update: (id, data) => request(`/products/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  delete: (id) => request(`/products/${id}`, { method: 'DELETE' }),
};

export const authApi = {
  register: (data) => request('/auth/register', { method: 'POST', body: JSON.stringify(data) }),
  login: async (email, password) => {
    const data = await request('/auth/login', { method: 'POST', body: JSON.stringify({ email, password }) });
    localStorage.setItem('token', data.token);
    localStorage.setItem('client', JSON.stringify(data.client));
    return data;
  },
  logout: () => { localStorage.removeItem('token'); localStorage.removeItem('client'); },
  me: () => request('/auth/me'),
};

export const ordersApi = {
  getAll: () => request('/orders'),
  create: (items, comment) => request('/orders', { method: 'POST', body: JSON.stringify({ items, comment }) }),
  updateStatus: (id, status) => request(`/orders/${id}`, { method: 'PUT', body: JSON.stringify({ status }) }),
};
